import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  DialogActions,
  Button,
  Stack,
  Typography,
  Checkbox,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setTheme } from "../../application/ApplicationActions";
import { GENIEBOARD_THEMES } from "../../constants";

export default function NoeThemeSwitch(props) {
  const { open, setOpen } = props;

  const applicationState = useSelector((state) => state.application);
  const dispatch = useDispatch();
  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleChangeTheme = (index) => {
    dispatch(setTheme(index));
  };

  return (
    <Dialog open={open} onClose={handleCloseDialog}>
      <DialogTitle>Select your preffered theme</DialogTitle>
      <DialogContent>
        <Box sx={{ p: 2 }}>
          <Stack direction="column" spacing={1}>
            {GENIEBOARD_THEMES.map((item) => (
              <Box
                sx={{
                  width: 200,
                  height: 100,
                  backgroundColor: item.primary,
                  borderRadius: 2,
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => handleChangeTheme(item.index)}
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography variant="body2">{item.name}</Typography>
                  {applicationState?.themeIndex === item.index && (
                    <Typography variant="caption" color={"#fff"}>
                      Active
                    </Typography>
                  )}
                </Stack>
              </Box>
            ))}
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} color="primary">
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
}
